import { assertNever } from '@varos/util-typescript';
import { ChatContainerBaseConfig } from '../base';
import { MessagePartController } from './messagePartInterface';
import { MessagePartContainerProps } from './messagePartProps';
import { CallToolContainerProps } from './call';
import { SolutionToolContainerProps } from './solution';
import { TextMessagePartViewProps } from './text';

export function createMessagePartContainer(
    config: ChatContainerBaseConfig & {
        Container: {
            Tool: {
                Call: React.FC<CallToolContainerProps>;
                Solution: React.FC<SolutionToolContainerProps>;
            };
        };
    },
    controller: MessagePartController
): React.FC<MessagePartContainerProps> {
    const {
        context: { useContext },
        Container: {
            Tool: { Call: CallToolContainer, Solution: SolutionToolContainer },
        },
    } = config;
    return ({ as, item, ...containerProps }) => {
        const context = useContext();
        const props = controller.useProps(context, item, containerProps);
        const { Text: TextView, CallTool: CallView, SolutionTool: SolutionView } = as;
        if (props.component.kind === 'text') {
            return <TextView {...props.component} />;
        }
        if (props.component.kind === 'call') {
            return <CallToolContainer as={CallView} {...props.component} />;
        }
        if (props.component.kind === 'solution') {
            return <SolutionToolContainer as={SolutionView} {...props.component} />;
        }
        assertNever(props.component);
    };
}
